import { forwardRef } from 'react';

import { FieldWrapper } from '../FieldWrapper/FieldWrapper';

export interface InputFieldProps extends Omit<
  React.InputHTMLAttributes<HTMLInputElement>,
  'prefix'
> {
  defaultValue?: string;
  label?: string;
  note?: string | React.ReactNode;
  error?: string;
  hideErrorMessage?: boolean;
  prefix?: React.ReactNode;
  suffix?: React.ReactNode;
  dataTestid?: string;
  textAlign?: 'left' | 'center';
  inputmode?: 'numeric';

  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onFocus?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (e: React.ChangeEvent<HTMLInputElement>) => void;

  onKeyDown?: React.KeyboardEventHandler<HTMLInputElement>;
}

export const InputField = forwardRef<HTMLInputElement, InputFieldProps>(
  (
    {
      dataTestid,
      defaultValue,
      disabled = false,
      error,
      hideErrorMessage = false,
      id,
      label,
      name,
      note,
      prefix,
      required = false,
      suffix,
      textAlign = 'left',
      type = 'text',
      ...rest
    },
    ref,
  ) => {
    return (
      <FieldWrapper
        disabled={disabled}
        error={error}
        hideError={hideErrorMessage}
        id={id}
        label={label}
        note={note}
      >
        {prefix && <span>{prefix}</span>}
        <input
          ref={ref}
          autoCapitalize="off"
          autoComplete="off"
          autoCorrect="off"
          className={textAlign === 'center' ? 'text-center' : 'text-left'}
          data-testid={dataTestid}
          defaultValue={defaultValue}
          disabled={disabled}
          id={id}
          name={name}
          required={required}
          type={type}
          {...rest}
        />
        {suffix && <span>{suffix}</span>}
      </FieldWrapper>
    );
  },
);
